import type { LandingPageLink, OfferLandingPages } from "./types";

export const pickDefaultLandingPage = (
  offer: OfferLandingPages,
  preferredLanguage?: string,
): LandingPageLink | undefined => {
  const pages = offer.landingPages ?? [];
  if (preferredLanguage) {
    const match = pages.find((lp) => lp.languageCode === preferredLanguage);
    if (match) return match;
  }
  return pages.find((lp) => lp.languageCode === "en") ?? pages[0];
};
